import { LimiterWithUniqueLimitsBase } from "@/services/license/license-limiters/base-limiters/limiter-with-unique-limits";
import { LicenseName } from "@/data/license.data";

export type TrainQualityPresetType = "low" | "default" | "highest";
type QualityCheckResult = {
  isQualityAllowed: boolean;
  maxQuality: TrainQualityPresetType;
};

export class CustomVoiceQualityLimiter extends LimiterWithUniqueLimitsBase<TrainQualityPresetType> {
  static TrainQualityRank: TrainQualityPresetType[] = [
    "low",
    "default",
    "highest",
  ];

  getPlanLimit(license: LicenseName): TrainQualityPresetType {
    switch (license) {
      case "Trial":
        return "low";
      default:
        return "highest";
    }
  }

  getUniqueLimit(userId: string): Promise<TrainQualityPresetType | null> {
    return Promise.resolve(null);
  }

  async isQualityAllowed(
    userId: string | null,
    license: LicenseName,
    quality: TrainQualityPresetType,
  ): Promise<QualityCheckResult> {
    if (!userId) {
      return {
        isQualityAllowed:
          CustomVoiceQualityLimiter.TrainQualityRank.indexOf(quality) === 0,
        maxQuality: CustomVoiceQualityLimiter.TrainQualityRank[0],
      };
    }

    const maxQuality = await this.getLimit(userId, license);
    const isQualityAllowed =
      CustomVoiceQualityLimiter.TrainQualityRank.indexOf(quality) <=
      CustomVoiceQualityLimiter.TrainQualityRank.indexOf(maxQuality);

    return {
      isQualityAllowed,
      maxQuality,
    };
  }
}
